<script setup>
import { RadioGroupRoot } from "radix-vue";
import { cn } from "@/lib/utils";

const props = defineProps({
  modelValue: { type: String, default: undefined },
  class: { type: String, default: "" },
  name: { type: String, default: undefined },
  required: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false }
});
const emits = defineEmits(["update:modelValue"]);
</script>

<template>
  <RadioGroupRoot
    :class="cn('grid gap-2', props.class)"
    :model-value="props.modelValue"
    :name="props.name"
    :required="props.required"
    :disabled="props.disabled"
    @update:model-value="emits('update:modelValue', $event)"
  >
    <slot />
  </RadioGroupRoot>
</template>
